import { create } from 'zustand';
import { Notice } from '~/types';
import { SECOND } from '~/constants';

const TOAST_REMOVE_DELAY = 3 * SECOND;

export type ToastStore = {
  show: boolean;
  text: string;
  type: Notice;
  showToast: (type: Notice, text: string) => void;
};

const useToast = create<ToastStore>((set) => ({
  show: false,
  text: '',
  type: 'success',
  showToast: (type, text) => {
    set(() => ({ show: true, text, type }));

    setTimeout(() => {
      set(() => ({ show: false, text: '', type: 'success' }));
    }, TOAST_REMOVE_DELAY);
  },
}));

export default useToast;
